import React, {useEffect, useState} from "react";
import {cloneDeep} from "lodash";
import {arrayIncludeItem} from "@app/utils/CommonUtils";
import Select from "react-select";
import {SavedListTabOptions} from "@pages/savedlist/common/Constant";
import ReactChipInput from "react-chip-input";
import {CANDIDATE_CATEGORY_FIELDS, ResponseCode as ResponseStatus} from "@app/constants/Common";
import * as CandidateService from "@app/services/CandidateService";

const InitSearchConditions = {
    categories: {},
    exclude_receiver_sent_brief_uv: true
}

const DVTJCUVSearchCddJobSourceModeQuickSearch = (props) => {
    const [searchConditions, setSearchConditions] = useState(cloneDeep(InitSearchConditions));
    const [isSearching, setIsSearching] = useState(false);

    const {cddId, searching, onSearch} = props
    useEffect(() => {
        setIsSearching(searching)
    }, [searching])

    const fetchCategories = async (canId) => {
        const res = await CandidateService.getCandidateCategoryDetail(canId)
        if (res.sts_code === ResponseStatus.SUCCESS) {
            searchConditions.categories = res.content
            setSearchConditions({...searchConditions})
            onSearch(searchConditions)
        } else {
            onSearch({})
        }
    };

    useEffect(() => {
        if (cddId) {
            fetchCategories(cddId)
        }
    }, [cddId])

    const onSearchClick = () => {
        return onSearch(searchConditions)
    }

    const onClearSearchCondition = () => {
        setSearchConditions(cloneDeep(InitSearchConditions));
    }

    const onAddCategoryItem = (value, fieldName) => {
        if (!value) {
            return;
        }
        let arr = cloneDeep(searchConditions.categories[fieldName])
        if (!arr) {
            arr = []
        }

        if (!arrayIncludeItem(arr, value)) {
            arr.push(value)
            searchConditions.categories[fieldName] = arr
            setSearchConditions({...searchConditions})
        } else {
            alert('Không được phép nhập các giá trị giống nhau tại cùng 1 trường.')
        }
    }

    const onRemoveCategoryItem = (index, fieldName) => {
        let arr = cloneDeep(searchConditions.categories[fieldName])
        if (arr && arr.length > 0) {
            if (arr.length === 1) {
                arr = []
            } else {
                arr.splice(index, 1);
            }
            searchConditions.categories[fieldName] = arr
            setSearchConditions({...searchConditions})
        }
    }

    const setNotExcludeReceiverSentBriefUV = (event) => {
        const value = searchConditions.exclude_receiver_sent_brief_uv
        searchConditions.exclude_receiver_sent_brief_uv = !value;
        setSearchConditions({...searchConditions});
    };

    return (
        <div className="card card-default">
            <div className="card-header">
                <h3 className="card-title text-bold">Search</h3>
                <button type="button" className="btn btn-tool" data-card-widget="collapse">
                    <i className="fas fa-minus"/>
                </button>
                <div className="card-tools pr-2">
                    <button
                        type='button'
                        className='btn btn-default mr-3'
                        onClick={() => onClearSearchCondition()}
                    >
                        {'Clear'}
                    </button>
                    <button
                        type='button'
                        className='btn btn-primary'
                        onClick={onSearchClick}
                        disabled={isSearching}
                    >
                        {isSearching ? 'Searching...' : 'Search'}
                    </button>
                </div>
            </div>
            <div className="card-body">
                <div className={"row"}>
                    {CANDIDATE_CATEGORY_FIELDS.map((field, i) => {
                        let fieldValue = searchConditions.categories[field.key] ?
                            searchConditions.categories[field.key] : []
                        if (field.key === 'industry_function') {
                            return ""
                        }
                        return <div className='input-group col-sm-6 mt-3'>
                            <label className={'w-100'}>{field.label}</label>
                            <ReactChipInput
                                classes="class1 class2 w-100"
                                chips={fieldValue}
                                onSubmit={value => onAddCategoryItem(value, field.key)}
                                onRemove={index => onRemoveCategoryItem(index, field.key)}
                            />
                        </div>
                    })}

                    <div className='input-group col-sm-12 mt-3'>
                        <label>Loại Rec đã gửi Brief UV</label>
                        <input type="checkbox"
                               className="ml-3" name={'check_only_search_advance_user_input'}
                               style={{width: 20, height: 20}}
                               value={!!searchConditions.exclude_receiver_sent_brief_uv}
                               checked={searchConditions.exclude_receiver_sent_brief_uv === true}
                               onChange={event => setNotExcludeReceiverSentBriefUV(event)}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DVTJCUVSearchCddJobSourceModeQuickSearch;
